export const CART_ARTICLE_ACTION_MODE = {
  INTERACTIVE: 'interactive',
  READ_ONLY: 'read-only'
} as const;

export const MAX_CART_ARTICLE_QUANTITY = 9999;
